import React from 'react';
import Link from '../components/link';

const links = [
  {
    name: 'Home',
    url: '/'
  },
  {
    name: 'About',
    url: '/about/'
  },
  {
    name: 'Contact',
    url: '/contact/'
  },
];

export default () =>
  <div
    css={{
      padding: '1.5rem',
      borderBottom: '1px solid #979797',
      boxShadow: '0px 2px 4px 0px rgba(0,0,0,0.5)'
    }}
  >
    <nav
      css={{
        margin: '2rem auto',
        maxWidth: '960px',
        textAlign: 'center'
      }}
    >
      {
        links.map((link, index) =>
          <Link
            key={index}
            to={link.url}
            css={{
              color: '#000000',
              fontSize: '1.8em',
              margin: '0 4.5rem',
              padding: '0.5rem',
              textDecoration: 'none',
              borderBottom: '2px solid #25ced1',
              '&:hover': {
                backgroundColor: '#25ced1',
                backgroundImage: 'linear-gradient(45deg, rgba(0,0,0, 0.1) 25%, transparent 25%, transparent 50%, rgba(0,0,0, 0.1) 50%, rgba(0,0,0, 0.1) 75%, transparent 75%, transparent)',
                borderRadius: '5px',
                color: '#fffffc',
                transition: 'background-color 0.5s, color 0.5s',
                '--webkit-transition': 'background-color 0.5s, color 0.5s',
              },
              '@media (max-width: 520px)': {
                fontSize: '1.6em',
                margin: '0 2rem',
              },
              '@media (max-width: 374px)': {
                margin: '0 1.5rem',
              }
            }}
            alt={link.name}
          >
            {link.name}
          </Link>
        )
      }
    </nav>
  </div>;



// WEBPACK FOOTER //
// ./src/components/header.js